window.injectEnvVars = function (envVars = {
    MILESTONES_API_PREFIX: null,
    MILESTONES_API_VERSION: null,
    MILESTONES_API_HOST: null,
    MILESTONES_API_AUTH_URL: null,
    MILESTONES_API_GET_AUTHENTICATED_USER_URL: null,
    MILESTONES_AUTHORIZATION_HEADER_KEY: null,
    GOOGLE_API_KEY: null,
    GOOGLE_TAG_MANAGER_ID: null,
    MILESTONES_RE_MANAGER_HOST: null,
    MILESTONES_HELP_CENTER: null,
    MILESTONES_AUTH_ENDPOINT: null,
    MILESTONES_AUTH_CLIENT_MODE: null,
    MILESTONES_WEBSITE_HOST: null,
    CSRF_TOKEN: null,
    MILESTONES_UNIFIED_LOGIN: null,
    HUBSPOT_PORTAL_ID: null,
    HUBSPOT_REQUEST_MLS_FORMS_FORM_ID: null,
    MILESTONES_TERMS_OF_USE_ENDPOINT: null,
    MILESTONES_PRIVACY_POLICY_ENDPOINT: null,
    HJ_HOST: null,
    HJ_PUBLIC_KEY: null,
    HJ_TOKEN_HEADER: null,
    HOME_OWNERSHIP_DESCRIPTIVE_VIDEO_ID: null,
    APP_ENV: null,
    MILESTONES_DOMAIN: null,
    BUGSNAG_API_KEY: null,
    MILESTONES_HLP_HOST: null,
}) {

    window.env = [];

    Object.keys(envVars).forEach((key) => {
        window.env[key] = envVars[key];
    });
};
